const PerformanceReviewsPage = () => {
    return (
        <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-200">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Performance Reviews</h1>
            <p className="text-gray-600 dark:text-gray-400">This is the Performance Reviews page. CRUD will be added later.</p>
        </div>
    );
};

export default PerformanceReviewsPage;
